var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "popup_wrap",
      staticStyle: { width: "380px", height: "430px", overflow: "none" },
    },
    [
      _c(
        "button",
        {
          staticClass: "layer_close",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_vm._v("close")]
      ),
      _c("div", { staticClass: "popup_cont cod_cont_area" }, [
        _c("h1", { staticClass: "page_title" }, [
          _vm._v(" " + _vm._s(_vm.$t("msg.ONEX010T010.161")) + " "),
        ]),
        _c("div", { staticClass: "content_box" }, [
          _c("div", { staticClass: "clearfix" }, [
            _c("div", { staticClass: "float_left" }, [
              _c(
                "table",
                {
                  staticClass: "tbl_list font_sm gridtype",
                  staticStyle: { border: "1px solid #e1e3eb" },
                },
                [
                  _vm._m(0),
                  _c("thead", [
                    _c("tr", [
                      _c("th", [_vm._v("No.")]),
                      _c("th", [_vm._v(_vm._s(_vm.$t("msg.ONEX050G020.003")))]),
                      _c("th", [_vm._v(_vm._s(_vm.$t("msg.ONEX050G020.018")))]),
                      _c("th", [_vm._v(_vm._s(_vm.$t("msg.ONEX050G020.045")))]),
                    ]),
                  ]),
                  _c(
                    "tbody",
                    _vm._l(_vm.list, function (vo, idx) {
                      return _c("tr", { key: idx }, [
                        _c("td", [_vm._v(_vm._s(vo.rowCd))]),
                        _c("td", [_vm._v(_vm._s(vo.cntrNo))]),
                        _c("td", { staticStyle: { "text-align": "end" } }, [
                          _vm._v(
                            _vm._s(vo.rmk.replace(/\B(?=(\d{3})+(?!\d))/g, ","))
                          ),
                        ]),
                        _c("td", [_vm._v(_vm._s(vo.pkg))]),
                      ])
                    }),
                    0
                  ),
                ]
              ),
            ]),
            _c("span", { staticClass: "ml_auto cal_btn" }, [
              _c(
                "a",
                {
                  staticClass: "button sm",
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.exlDownload()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("msg.MYIN020T010.016")))]
              ),
            ]),
          ]),
          _c(
            "div",
            {
              staticClass: "normal_box",
              staticStyle: { "background-color": "#FFF4F2" },
            },
            [
              _c("ol", [
                _c(
                  "li",
                  {
                    staticStyle: {
                      color: "#ff0000",
                      "white-space": "pre-line",
                      "list-style": "none",
                      display: "table",
                      margin: "0 auto",
                      "text-align": "left",
                      "font-weight": "500",
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("msg.ONEX010T010.176")))]
                ),
              ]),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "10%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "40%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "25%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "30%" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }